import { apiClient } from "./api";

// AI credits.
//
// The platform calls take a store id because Kumudu is acting on somebody
// else's store — the opposite of every other service here, and only reachable
// by the platform tenant. `mine` takes none: a store's own balance is resolved
// from the session token, and a store id parameter there would be a hole.
export const creditsService = {
  // ── Platform (Kumudu only) ────────────────────────────────────────────────

  /** → { stores[], prices, totals } */
  listStores: () => apiClient.get("/platform/stores"),

  /**
   * Customer stores that do NOT have hiring yet — the ones you can onboard.
   * Searched rather than listed: there are hundreds, and granting them credits
   * is what switches hiring on.
   */
  availableStores: (search = "") =>
    apiClient.get(`/platform/stores/available?q=${encodeURIComponent(search)}`),

  /** Negative credits revoke. A note is required by the server. */
  grant: (storeId, credits, note, expiresAt = null) =>
    apiClient.post(`/platform/stores/${storeId}/credits`, {
      credits,
      note,
      expires_at: expiresAt,
    }),

  ledger: (storeId, limit = 100) =>
    apiClient.get(`/platform/stores/${storeId}/ledger?limit=${limit}`),

  // ── Any store, about itself ───────────────────────────────────────────────

  /** → { balance, exempt, interviews_left, spent_30d, recent[] } */
  mine: () => apiClient.get("/credits"),
};

export default creditsService;
